import { render } from "./SatelliteStationModal.vue?vue&type=template&id=c70d0d66&scoped=true"
import script from "./SatelliteStationModal.vue?vue&type=script&lang=js"
export * from "./SatelliteStationModal.vue?vue&type=script&lang=js"

import "./SatelliteStationModal.vue?vue&type=style&index=0&id=c70d0d66&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70d0d66"]])

export default __exports__